export const stencilThickness = [
  {
    value: '',
    text: 'Select One',
  },
  {
    value: 'Select for Me',
    text: 'Select for Me',
  },
  {
    value: '0.004',
    text: '0.004',
  },
  {
    value: '0.005',
    text: '0.005',
  },
];
